export function geocodingResultTemplate( location, showOnMapText, goToMapCallback ) {
	const properties = location.properties ?? {};

	const resultElement = document.createElement( 'li' );
	resultElement.className = 'store-locator-map__list__item';

	resultElement.innerHTML = properties.popup_html;

	{
		const heading = resultElement.querySelector( 'h2' );
		if ( heading ) {
			heading.className = 'type-m';
		}

		const addressAndLinks = Array.from( resultElement.querySelectorAll( 'a, address' ) );
		addressAndLinks.forEach( ( addressOrLink ) => {
			addressOrLink.className = 'type-e';
		} );

		if ( resultElement.querySelector( 'a:last-child' ) ) {
			resultElement.appendChild( document.createElement( 'br' ) );
		}
	}

	const showOnMap = document.createElement( 'button' );
	showOnMap.type = 'button';
	showOnMap.className = 'link type-e';
	showOnMap.textContent = showOnMapText;

	showOnMap.addEventListener( 'click', goToMapCallback );

	resultElement.appendChild( showOnMap );

	return resultElement;
}
